document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 749) {
    let accordion_pdp = document.querySelector(
      ".product .accordion-js"
    );

    let element = accordion_pdp.querySelector(".description-info");

    if (element) {
      element.classList.remove("active");
    }
  }
  let productHeadingDescription = document.getElementById("accordion-parent-product");
  let productDescription = document.getElementById("accordion-product-description");
  let productDescriptionSplit = productDescription.innerHTML.split("Material and Care");
  let productMaterialCare = document.getElementById("accordion-material-and-care");
  if(productDescription && productDescriptionSplit.length>1){
    cleanElement(productDescription,productDescriptionSplit[0]);
  }
  if(productHeadingDescription){
    if (window.innerWidth > 749) {
      productHeadingDescription.classList.add('active');
    }
  }
  if(productMaterialCare){
    let productMaterialCareSplit = productMaterialCare.innerHTML.split("Material and Care");
    if(productMaterialCareSplit.length>1)
    cleanElement(productMaterialCare,productMaterialCareSplit[1]);
  }

  function cleanElement(element,innerHTML) {
    
    if (element) {
      let cleanContent = removeIncompleteTags(innerHTML.trim());
      let ulElements = extractUlElements(cleanContent);
      replaceElementContent(element, ulElements);
    }
  }

  function removeIncompleteTags(html) {
    
    let htmlClean = html
    .replace(/<p[^>]*>/g, function (match) {
      return match.endsWith("</p>") ? match : "";
    })
    .replace(/<div[^>]*>/g, function (match) {
      return match.endsWith("</div>") ? match : "";
    });
   
    return htmlClean; 
  }

  function extractUlElements(html) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(html, "text/html");
    return Array.from(doc.querySelectorAll("ul"));
  }

  function replaceElementContent(element, ulElements) {
    element.innerHTML = '';

    ulElements.forEach(function (ul) {
        var newUl = ul.cloneNode(true);
        element.appendChild(newUl);
    });
  }
});
